import FondEditForm from "../../components/Fonds/FondEditForm";
import { NavLink } from "react-router";

import { useFondPersoQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function FondPersoEdit(){

    const {translate}=useTrads();
    const { data:fond, error, isLoading } = useFondPersoQuery();

    return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>

        ) : fond ? (
            <div>
                <nav>
                    <ul  className="nav nav-tabs">
                        <li className="nav-item"><NavLink className="nav-link" to={`/perso/edit`}>{translate('btn_fond_edit')}</NavLink></li>
                    </ul>
                </nav>

                <FondEditForm fondParam={fond} perso={true}></FondEditForm>

            </div>

        ):null
    );
}
export default FondPersoEdit;